export default "__VITE_ASSET__jm7ATsWU__"